import React from "react"
import { Controlled as CodeMirror, IInstance } from "react-codemirror2"
import "codemirror/lib/codemirror.css"
import { Message, Text } from "@jjordy/layout"
import "codemirror/theme/material.css"
import "codemirror/mode/javascript/javascript"
import styled from "styled-components"
import { PoseGroup } from "react-pose"
import Appear from "./Animations/Appear"

const ErrorMessage = styled(Message)`
  margin-bottom: 0;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
`

export interface CodeMirrorProps {
  code: string
  onChange: (editor: IInstance, data: CodeMirror.EditorChange, value: string) => void
  onBeforeChange: (editor: IInstance, data: CodeMirror.EditorChange, value: string) => void
  error?: string
}

export default function MyCodeMirror({ code, onChange, onBeforeChange, error }: CodeMirrorProps) {
  return (
    <React.Fragment>
      <PoseGroup flipMove={false}>
        {error ? (
          <Appear key="code-error">
            <ErrorMessage bg="error" key="code-error">
              <Text small fg="white" m={0}>
                {error}
              </Text>
            </ErrorMessage>
          </Appear>
        ) : (
          <div key="no ERROR" />
        )}
      </PoseGroup>

      <CodeMirror
        value={code}
        options={{
          mode: "javascript",
          theme: "material",
          lineNumbers: true,
          tabSize: 2
        }}
        onBeforeChange={(editor, data, value) => onBeforeChange(editor, data, value)}
        onChange={(editor, data, value) => onChange(editor, data, value)}
      />
    </React.Fragment>
  )
}

MyCodeMirror.defaultProps = {
  onChange: () => {
    return
  },
  onBeforeChange: () => {
    return
  }
}
